import { createContext, Context } from 'react';
import { WixDesignSystemDefaultProps } from './types';

declare global {
  var __WDSDefaultPropsContext__:
    | Context<WixDesignSystemDefaultProps>
    | undefined;
}

if (!globalThis.__WDSDefaultPropsContext__) {
  globalThis.__WDSDefaultPropsContext__ =
    createContext<WixDesignSystemDefaultProps>({});
}

export const WixDesignSystemDefaultPropsContext =
  globalThis.__WDSDefaultPropsContext__;
